/*这些是导入所需的依赖项和模块。Vue是Vue框架的核心库，Vuex是用于状态管理的库，router是从@/js_router/router.js文件中导入的路由实例，
clearRouter是从同一个文件中导入的一个函数，用于清空路由。*/
import Vue from 'vue'
import Vuex from 'vuex'
import router from "@/js_router/router.js";
import {clearRouter} from "@/js_router/router.js";

/*这行代码使用Vuex插件，将Vuex与Vue应用程序集成起来。*/
Vue.use(Vuex)

/*这部分代码创建了一个名为myVuex的Vuex存储对象。它包含两个属性：state和mutations。*/
const myVuex = new Vuex.Store({
    /*自带state*/
    state: {
        currentPathName: '' // 当前路径名称
    }, /*自带mutations*/
    mutations: {
        setStateCurrentPathName(state) {
            state.currentPathName = localStorage.getItem("currentPathName")
        }, userLogout(state) { // 全局退出方法
            // 清空缓存
            localStorage.removeItem("user")
            localStorage.removeItem("menuList")
            router.push("/login")
            // 重置清空路由
            clearRouter()
        }
    }
})

/*最后一行代码导出了myVuex存储对象，以便在其他地方使用。*/
export default myVuex
